import { defaultLeadMaskElementsStandard, defaultLeadMaskElementsAdvanced, defaultExternalFormElements } from '@/config/data/dragDefaultElements'

import i18n from '@/i18n'

// Some functions for Drag elements etc.
class Drag {

  static generateElement(elementType, parentTitle) {
    let element = {
      name: '',
      class: '',
      element_type: elementType,
      parentTitle: parentTitle
    }
    if (elementType == 'text') {
      element.data_type = 'text'
    }
    if (Drag.allowedElementsList().includes(elementType)) {
      element.allowed_values = []
      element.default_value = null
      element.enrich_tags = false
    }
    if (Drag.allowedElementsListWithButtons().includes(elementType)) {
      element.allowed_values = []
      element.default_value = null
      element.show_as_buttons = false
      element.enrich_tags = false
    }
    if (Drag.allowedSpecialElementsList().includes(elementType)) {
      element.allowed_values = []
    }
    if (Drag.textInputElementsList().includes(elementType)) {
      element.placeholder = ''
      element.default_value = null
    }
    if (!Drag.textElementsList().includes(elementType)) {
      element.required = false
      element.hidden = false
    } else {
      element.content = ''
    }
    return element
  }

  static generateDefaultElements(editorType) {

    if (editorType == 'lead_sheet') {
      let title_standard = i18n.t('ui.drag_editor.dragElements.standard')
      var elements_standard = defaultLeadMaskElementsStandard().map((element) => {
        return Object.assign({}, Drag.generateElement(element.element_type, title_standard), element)
      })

      let title_advanced = i18n.t('ui.drag_editor.dragElements.advanced')
      var elements_advanced = defaultLeadMaskElementsAdvanced().map((element) => {
        return Object.assign({}, Drag.generateElement(element.element_type, title_advanced), element)
      })

      return [
        {
          title: title_standard,
          items: elements_standard
        },
        {
          title: title_advanced,
          items: elements_advanced
        }
      ]

      items = [...elements_advanced]
    } else {
      let title = i18n.t('ui.drag_editor.dragElements.generic')
      var items = defaultExternalFormElements().map((element) => {
        return Object.assign({}, Drag.generateElement(element.element_type, title), element)
      })

      return [{
        title: title,
        items: items
      }]
    }


  }

  static generateDefaultSubmitButton() {
    return {
      class: "",
      content: "Submit",
      element_type: "submit",
      hidden: false,
      name: "submit_button",
      parent_element: "root"
    }
  }

  // Convert Array format to structured Object required by LeadMasks and ExternalForms
  static arrayToStructure(array) {
    let structure = new Object
    array.forEach((item, idx) => {
      item.position        = idx.toString()
      structure[item.name] = item
    })
    return structure
  }

  // Since our newer external form implementation we have to convert some older elements
  static sanitizeOldFormElements(item, tabs, activeTab) {
    // Validate and sanitize parent element
    let parentElement = item.parent_element
    if (!parentElement) {
      parentElement   = activeTab.name
    } else if (!Object.keys(tabs).includes(parentElement)) {
      parentElement   = activeTab.name
    } else if (['top', 'bottom', 'container'].some((e) => parentElement.includes(e))) {
      // We have removed the old 'top' and 'bottom' containers and instead just use the tab
      parentElement   = item.tab
    }
    item.parent_element = parentElement

    // Some old buggy elements have allowed_value set and no content although they should have
    if (Drag.textInputElementsList().includes(item.element_type) && item.allowed_values) {
      delete item.allowed_values
      item.content = ''
    }

    // Remove custom element types
    if (item.element_type.includes('_custom')) {
      item.element_type = item.element_type.replace(/_custom/, '')
    } else if (item.element_type == 'hidden') {
      item.element_type = 'text'
      item.hidden = true
      item.required = false
    }
    return item
  }

  // the elements defined here will have an influence on the canEdit method on the DragItemEdit component
  // this should get refactored in favor of the elements and what attributes are allowed to get edited
  static textInputElementsList() {
    return ['text', 'textarea', 'readonly']
  }

  static allowedElementsList() {
    return ['select']
  }

  static allowedElementsListWithButtons() {
    return ['radio', 'checkbox']
  }

  static allowedSpecialElementsList() {
    return ['quantity_selection']
  }

  static textElementsList() {
    return ['confirmation', 'paragraph', 'title']
  }
}

export default Drag



// WEBPACK FOOTER //
// ./src/classes/Drag.js